import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {Baseline} from '../message/Baseline';
import {BaselineCriteria} from './BaselineCriteria';
import {BaselineScenario} from './BaselineScenario';

export class BaselineWrapper extends BaseWrapper<Baseline, BaselineCriteria, BaselineScenario>  {}

